import { Row, Col, Card, Badge, CardBody, CardTitle } from "reactstrap";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

import restro from "../../../assets/orderingSystem/restrologo.png";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination } from "swiper";

// Custom Swiper pagination styles
const paginationStyles = `
  .swiper-pagination-bullet {
    background-color: #ff9800 !important;
    opacity: 0.5;
  }
  
  .swiper-pagination-bullet-active {
    background-color: #ff9800 !important;
    opacity: 1;
  }
`;

const styleElement = document.createElement('style');
styleElement.innerHTML = paginationStyles;
document.head.appendChild(styleElement);
// ============= MENU ITEM CARD COMPONENT =============
const TouchBasedMenuItemCard = ({
  item,
  cartItem,
  onAdd,
  onRemove,
  onCardClick,
}) => (
  <Col xs={6} sm={6} md={3} lg={3}>
    <Card
      className="border-0"
      style={{
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        cursor: "pointer",
        padding: "6px",
      }}
      onClick={() => onCardClick && onCardClick(item)}
    >
      {/* Image Section */}
      <div
        style={{
          height: "90px",
          backgroundColor: "#fafafa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <img
          src={item.displayImage?.getCDNUrl() || restro}
          alt={item.name}
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
            padding: "5px",
          }}
          onError={(e) => (e.target.src = restro)}
        />
        {item.discount && (
          <Badge
            color="success"
            className="position-absolute"
            style={{
              top: "5px",
              right: "5px",
              fontSize: "8px",
              padding: "2px 5px",
            }}
          >
            {item.discount}
          </Badge>
        )}
      </div>

      {/* Card Body */}
      <CardBody
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          gap: "6px",
        }}
      >
        {/* Product Name */}
        <CardTitle
          tag="h6"
          className="text-center mb-0"
          style={{
            fontSize: "14px",
            fontWeight: "600",
            color: "#2c3e50",
            lineHeight: "1.2",
            height: "28px",
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
          }}
        >
          {item.name}
        </CardTitle>

        {/* Price + Eye Button */}
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <span
              className="fw-bold"
              style={{ fontSize: "14px", color: "#dc3545" }}
            >
              Rs. <NumberWithCommas number={item.price} />
            </span>
            {item.originalPrice && item.originalPrice > item.price && (
              <del className="ms-1" style={{ fontSize: "12px", color: "#aaa" }}>
                Rs. <NumberWithCommas number={item.originalPrice} />
              </del>
            )}
          </div>
          <button
            className="btn btn-soft-success btn-sm me-2"
            onClick={(e) => {
              playBeep();
              e.stopPropagation();
              onAdd(item);
            }}
          >
            <i className="ri-eye-2-line"></i>
          </button>
        </div>
      </CardBody>
    </Card>
  </Col>
);

// ============= MENU GRID COMPONENT =============

const TouchBasedMenuGrid = ({
  filteredItems,
  cart,
  onAdd,
  onRemove,
  onCardClick,
  multipleTenant,
}) => {
  const ITEMS_PER_PAGE = 16;
  if (filteredItems.length === 0) {
    return (
      <div className="text-center py-5">
        <i
          className="bx bx-food-menu"
          style={{ fontSize: "48px", color: "#ccc" }}
        />
        <p className="text-muted mt-2" style={{ fontSize: "13px" }}>
          No items available
        </p>
      </div>
    );
  }

  // Split items into pages of 16
  const pages = [];
  for (let i = 0; i < filteredItems.length; i += ITEMS_PER_PAGE) {
    pages.push(filteredItems.slice(i, i + ITEMS_PER_PAGE));
  }

  return (
    <Swiper
      spaceBetween={10}
      slidesPerView={1} // Each page shows 1 slide (16 items)
      pagination={{ clickable: true }}
      modules={[Pagination]}
    >
      {pages.map((pageItems, pageIndex) => (
        <SwiperSlide key={pageIndex}>
          <div style={{ paddingRight: "8px" }}>
            <div className="row">
              {pageItems.map((item) => {
                const cartItem = cart.find((i) => i.id === item.id);
                return (
                  <TouchBasedMenuItemCard
                    key={item.id}
                    item={item}
                    cartItem={cartItem}
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onCardClick={onCardClick}
                    multipleTenant={multipleTenant}
                  />
                );
              })}
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default TouchBasedMenuGrid;
export { TouchBasedMenuItemCard };
